export default interface RELATIONSHIPS
{
	ID                            : string  ; // uniqueidentifier
	RELATIONSHIP_NAME             : string  ; // nvarchar
	LHS_MODULE                    : string  ; // nvarchar
	LHS_TABLE                     : string  ; // nvarchar
	LHS_KEY                       : string  ; // nvarchar
	RHS_MODULE                    : string  ; // nvarchar
	RHS_TABLE                     : string  ; // nvarchar
	RHS_KEY                       : string  ; // nvarchar
	JOIN_TABLE                    : string  ; // nvarchar
	JOIN_KEY_LHS                  : string  ; // nvarchar
	JOIN_KEY_RHS                  : string  ; // nvarchar
	RELATIONSHIP_TYPE             : string  ; // nvarchar
	RELATIONSHIP_ROLE_COLUMN      : string  ; // nvarchar
	RELATIONSHIP_ROLE_COLUMN_VALUE: string  ; // nvarchar
	REVERSE                       : boolean ; // bit
}

